import React from "react";
import { secondaryTextColorOppositeShade } from "../../utils/constants";

export default function ExpandIconRound({ color = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="606.76" height="606.76" viewBox="0 0 606.76 606.76">
      <g id="up-arrow-3" transform="translate(606.76 606.76) rotate(180)">
        <g id="Gruppe_20" data-name="Gruppe 20">
          <path
            id="Pfad_26"
            data-name="Pfad 26"
            d="M303.38,0C136.091,0,0,136.091,0,303.38S136.091,606.76,303.38,606.76,606.76,470.669,606.76,303.38,470.669,0,303.38,0ZM447.662,371.817a25.269,25.269,0,0,1-35.749,0L303.38,263.283,194.846,371.817A25.278,25.278,0,1,1,159.1,336.069L285.507,209.66a25.254,25.254,0,0,1,35.748,0L447.663,336.069A25.252,25.252,0,0,1,447.662,371.817Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
}
